import { Component } from 'react'
import { connect } from 'react-redux'

import BodyClass from 'components/Shared/BodyClass'

import { getConnected, getRemovedFromRoom, getTimedOut } from 'ducks/sockets'

import './OfflineBanner.css'

class OfflineBanner extends Component {
  render() {
    const { connected, timedOut, removedFromRoom } = this.props

    if (timedOut || removedFromRoom) {
      return null
    }

    return (
      <>
        {connected ? null : <BodyClass className="offline-banner-visible" />}
        <div className="offline-banner">
          We're having difficulties connecting to our servers. Visit our{'  '}
          <a href="https://status.adalo.com" target="_blank" rel="noreferrer">
            status page
          </a>
          {'  '}
          and check your internet connection.{'  '}
        </div>
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    connected: getConnected(state),
    timedOut: getTimedOut(state),
    removedFromRoom: getRemovedFromRoom(state),
  }
}

export default connect(mapStateToProps)(OfflineBanner)
